// src/components/WeatherCard.ts
import "./WeatherCard.css";

export async function renderWeatherCard(container: HTMLElement, query: string) {
  container.innerHTML = `<div class="card-container weather-card">Loading weather...</div>`;

  // ⭐ Normalize query
  let q = query.toLowerCase().trim();

  // ⭐ If the user typed only "weather", treat it as no location
  if (q === "weather") {
    q = "";
  }

  // ⭐ Extract location from query (handles "weather in tokyo")
  let location = q.replace("weather in", "").trim();

  // ⭐ If no location in query, use stored location
  if (!location) {
    const stored = localStorage.getItem("ayesearch_user_location");
    if (stored) {
      location = stored;
    } else {
      container.innerHTML = `
        <div class="card-container weather-card">
          <p>Please allow location access.</p>
        </div>
      `;
      return;
    }
  }

  // ⭐ Fetch real weather (via backend proxy)
  try {
    const res = await fetch(
      `https://api.ayesearch.com/api/ai/weather/?q=${encodeURIComponent(location)}`,
    );

    const data = await res.json();

    if (data.error) {
      container.innerHTML = `
        <div class="card-container weather-card">
          <p>${data.error.message}</p>
        </div>
      `;
      return;
    }

    const current = data.current;
    const loc = data.location;

    container.innerHTML = `
      <div class="card-container weather-card">
        <div class="card-title">Weather</div>

        <div class="weather-main">
          <img src="${current.condition.icon}" class="weather-icon" />
          <div class="weather-temp">${current.temp_f}°F</div>
          <div class="weather-condition">${current.condition.text}</div>
        </div>

        <div class="weather-meta">
          <span>Feels like: ${current.feelslike_f}°F</span>
          <span>Humidity: ${current.humidity}%</span>
          <span>Wind: ${current.wind_mph} mph</span>
          <span class="weather-location">${loc.name}, ${loc.region}, ${loc.country}</span>
        </div>
      </div>
    `;
  } catch (err) {
    container.innerHTML = `
      <div class="card-container weather-card">
        <p>Unable to load weather data.</p>
      </div>
    `;
  }
}
